import type { PerfilVeiculo } from '../../dominio/didatico/perfilVeiculo'
import type { ConfiguracaoVeiculo } from '../../dominio/didatico/configuracaoVeiculo'
import { alvoCamera, POSICAO_PADRAO, type Vetor } from '../camera/comandosCamera'

export interface EnquadramentoInterior {
  posicao: Vetor
  alvo: Vetor
}

/**
 * Vista pela porta disponível, olhando para o habitáculo — a mesma pose serve
 * ao comando "Interior" da trilha de câmera e ao enquadramento inicial da
 * Extração (`CameraDaExtracao`, em `Visualizador3D.tsx`), para as duas pontas
 * não divergirem.
 *
 * Posições calibradas por revisão visual (capturas de tela antes/depois,
 * Fase 1 e Fase 2 do plano de aprimoramentos): olhar o veículo tombado ou
 * capotado de longe, na mesma distância da vista padrão, deixava o contato
 * corpo–prancha pequeno demais e atrás da estrutura translúcida do veículo.
 * Sobre as rodas a pose padrão já enquadra bem o habitáculo, então reaproveita
 * `POSICAO_PADRAO`/`alvoCamera` em vez de um terceiro valor.
 */
export function enquadramentoInteriorExtracao(
  perfil: PerfilVeiculo,
  configuracao: ConfiguracaoVeiculo,
): EnquadramentoInterior {
  switch (configuracao) {
    case 'invertido':
      return { posicao: [-2.8, 3.3, 2.6], alvo: [0, Math.max(0.48, perfil.tetoY * 0.34), 0] }
    case 'lateral':
      return { posicao: [-2.8, 4.2, 2.6], alvo: [0, perfil.largura * 0.5, 0] }
    case 'sobreRodas':
      return { posicao: POSICAO_PADRAO, alvo: alvoCamera(perfil) }
  }
}
